import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "number2Circle"
const Number2CircleIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm2 0c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11ZM11.96 8.15c-.705 0-1.215.48-1.425 1.185l-1.86-.555a3.452 3.452 0 0 1 3.315-2.43c1.8 0 3.36 1.35 3.36 3.24 0 1.275-.645 2.205-1.35 3.015L11.765 15.2h3.66V17H8.6v-1.2l3.69-4.185c.81-.915 1.035-1.515 1.035-2.055 0-.735-.57-1.41-1.365-1.41Z"
          />
        </svg>
      }
    </span>
  )
}
export default Number2CircleIcon
